import React from 'react'
import LostImg from '../assets/pnf.png';
import { useNavigate } from 'react-router-dom';


const PageNotFound = () => {

  const navigate = useNavigate();

  return (
    <>
    <section className='container text-center vh-100 align-content-center'>
      <img src={LostImg} className='img-fluid' alt='Page not found' /><br />
      <button className='pnf-btn animate__animated animate__pulse animate__infinite' onClick={() => navigate('/')}>Click Here</button>
    </section>
    </>
  )
}

export default PageNotFound;
